module.exports = __webpack_public_path__ + "static/media/leetcode.55fce3b2.png";